<router-outlet />
<app-alert />
